import { jsx } from "react/jsx-runtime";
import { createContext } from "react";
import { isValidEventType, showLogs } from "./utils.js";
const AmplitudeContext = /*#__PURE__*/ createContext(void 0);
const noopLogEvent = (logEventConfig)=>{
    if (!isValidEventType(logEventConfig.event)) return;
    showLogs(logEventConfig);
    if (logEventConfig.callback) logEventConfig.callback();
};
const NOOP_AMPLITUDE_CONTEXT_VALUE = {
    amplitude: void 0,
    logEvent: noopLogEvent
};
const AmplitudeProvider = ({ apiKey: _apiKey, platform: _platform = 'Web', children, user: _userProp })=>/*#__PURE__*/ jsx(AmplitudeContext.Provider, {
        value: NOOP_AMPLITUDE_CONTEXT_VALUE,
        children: children
    });
const Amplitude_AmplitudeContext = AmplitudeProvider;
export default Amplitude_AmplitudeContext;
export { AmplitudeContext };
